import { ReactElement, useEffect, useState } from 'react'
import { DashboardCard, Icon } from 'bd-web-components'
import {
  useGetCurrentMonthAdvanceTefData,
  useGetCurrentMonthAdvanceWebData,
} from '../../../hooks/advanced-analytics-v2'
import Loader from '../../../components/Loader'
import { TitleChart, CardsRow } from './styles'

export function AnalyticsCurrentWeb(): ReactElement {
  const [data, setData] = useState<any>(null)

  const {
    currentMonthWebData,
    currentMonthWebDataLoading,
    currentMonthWebDataError,
  } = useGetCurrentMonthAdvanceWebData()

  useEffect(() => {
    if (currentMonthWebData !== undefined) {
      console.log('current-web', currentMonthWebData)
      const data = currentMonthWebData[0]
      setData([
        {
          label: 'Total Antecipado',
          value: data.totalRequested,
          icon: 'checked',
        },
        {
          label: 'Potencial Antecipável',
          value: data.totalSalesWithFees,
          icon: 'creditCard',
        },
        {
          label: 'Taxa média',
          value: data.averageRate,
          icon: 'businessListFormat',
        },
        {
          label: 'Taxa de Conversão',
          value: data.totalConversion,
          icon: 'businessListFormat',
        },
        {
          label: 'Faturamento',
          value: data.totalRevenue,
          icon: 'dashboardTicketIcon',
        },
      ])
      // setData(sortByMonth(last6MonthWebData, 'desc'))
    }
  }, [
    currentMonthWebData,
    currentMonthWebDataLoading,
    currentMonthWebDataError,
  ])

  return (
    <>
      {data !== null && (
        <>
          <TitleChart>Indicadores do Mês - WEB </TitleChart>
          <br />
          <CardsRow>
            {data.map((indicador: any) => (
              <DashboardCard
                variateCardDescriptionText={indicador.label}
                variateValue={indicador.value}
                isMonetaryValue={false}
              >
                <Icon
                  fill="#333333"
                  classes="question-circle-help-center"
                  iconName={indicador.icon}
                  width={27}
                  height={23}
                />
              </DashboardCard>
            ))}
          </CardsRow>
        </>
      )}

      {currentMonthWebDataLoading && (
        <>
          <TitleChart>Indicadores do Mês - WEB </TitleChart>
          <div
            style={{
              height: '150px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #3333',
              borderRadius: '8px',
            }}
          >
            <Loader />
          </div>
        </>
      )}
      {currentMonthWebDataError && !currentMonthWebDataLoading && (
        <>
          <TitleChart>Indicadores do Mês - WEB </TitleChart>
          <div
            style={{
              height: '150px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #3333',
              borderRadius: '8px',
            }}
          >
            Um erro aconteceu, tente novamente!
          </div>
        </>
      )}
    </>
  )
}

export function AnalyticsCurrentTef(): ReactElement {
  const [data, setData] = useState<any>(null)

  const {
    currentMonthTefData,
    currentMonthTefDataLoading,
    currentMonthTefDataError,
  } = useGetCurrentMonthAdvanceTefData()

  useEffect(() => {
    if (currentMonthTefData !== undefined) {
      console.log('current-tef', currentMonthTefData)
      const data = currentMonthTefData[0]
      setData([
        {
          label: 'Total Antecipado',
          value: data.totalRequested,
          icon: 'checked',
        },
        {
          label: 'Potencial Antecipável',
          value: data.totalSalesWithFees,
          icon: 'creditCard',
        },
        {
          label: 'Taxa média',
          value: data.averageRate,
          icon: 'businessListFormat',
        },
        {
          label: 'Taxa de Conversão',
          value: data.totalConversion,
          icon: 'businessListFormat',
        },
        {
          label: 'Faturamento',
          value: data.totalRevenue,
          icon: 'dashboardTicketIcon',
        },
      ])
      // setData(sortByMonth(last6MonthWebData, 'desc'))
    }
  }, [
    currentMonthTefData,
    currentMonthTefDataLoading,
    currentMonthTefDataError,
  ])

  return (
    <>
      {data !== null && (
        <>
          <TitleChart>Indicadores do Mês - TEF </TitleChart>
          <br />
          <CardsRow>
            {data.map((indicador: any) => (
              <DashboardCard
                variateCardDescriptionText={indicador.label}
                variateValue={indicador.value}
                isMonetaryValue={false}
              >
                <Icon
                  fill="#333333"
                  classes="question-circle-help-center"
                  iconName={indicador.icon}
                  width={27}
                  height={23}
                />
              </DashboardCard>
            ))}
          </CardsRow>
        </>
      )}

      {currentMonthTefDataLoading && (
        <>
          <TitleChart>Indicadores do Mês - TEF </TitleChart>
          <div
            style={{
              height: '150px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #3333',
              borderRadius: '8px',
            }}
          >
            <Loader />
          </div>
        </>
      )}
      {currentMonthTefDataError && !currentMonthTefDataLoading && (
        <>
          <TitleChart>Indicadores do Mês - TEF </TitleChart>
          <div
            style={{
              height: '150px',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              border: '1px solid #3333',
              borderRadius: '8px',
            }}
          >
            Um erro aconteceu, tente novamente!
          </div>
        </>
      )}
    </>
  )
}
